export const RESTFUL = {
  billings: {
    list: 'v1/billings',
    read: 'v1/billings',
    create: 'v1/billings',
    update: 'v1/billings',
    void: 'v1/billings',
  },
  activityLogs: {
    list: 'v1/activityLogs',
    read: 'v1/activityLogs',
  },
  notifications: {
    list: 'v1/notifications',
    read: 'v1/notifications',
    create: 'v1/notifications',
    update: 'v1/notifications',
    delete: 'v1/notifications',
  },
  tables: {
    list: 'v1/tableManagements',
    read: 'v1/tableManagements',
    create: 'v1/tableManagements/create',
  },
  tableApplications: {
    list: 'v1/tableApplications/ownerTableApplicationWithStatusFilter',
    read: 'v1/tableApplications',
  },
  clockInRecords: {
    list: 'v1/admin/clockInRecords',
    read: 'v1/admin/clockInRecords',
    create: 'v1/admin/clockInRecord',
  },
  userAvailableTime: {
    list: 'v1/userAvailableTimes',
    read: 'v1/userAvailableTimes',
    create: 'v1/userAvailableTimes',
  },
  subscriptionPlanPurchaseRecord: {
    list: 'v1/SubscriptionPlanPurchaseRecords',
    read: 'v1/SubscriptionPlanPurchaseRecords',
    create: 'v1/SubscriptionPlanPurchaseRecords',
    update: 'v1/SubscriptionPlanPurchaseRecords',
  },
  user: {
    list: 'v1/users',
    read: 'v1/users',
    update: 'v1/users',
    create: 'v1/users/createUser', //TODO: change to another endpoint after the new user api is ready
  },
  profile: {
    list: 'v1/profiles',
    read: 'v1/profiles',
    create: 'v1/profiles',
    cashierCreate: 'v1/cashier/profiles',
    masterCreate: 'v1/master/profiles',
    masterRead: 'v1/master/profiles',
  },
  clientProfile: {
    list: 'v1/admin/clientProfiles',
    read: 'v1/admin/clientProfiles',
    create: 'v1/admin/clientProfiles',
    masterList: 'v1/master/clientProfiles',
  },
  masterProfile: {
    list: 'v1/admin/MasterProfiles',
    read: 'v1/admin/MasterProfiles',
    create: 'v1/admin/MasterProfiles',
  },
  serviceProducts: {
    list: 'v1/admin/serviceProducts',
    read: 'v1/admin/serviceProducts',
    create: 'v1/admin/serviceProducts',
    masterList: 'v1/master/serviceProducts',
  },
  productCategories: {
    list: 'v1/admin/productCategories',
    read: 'v1/admin/productCategories',
    create: 'v1/admin/productCategories',
    masterList: 'v1/master/productCategories',
  },
  leaveApplication: {
    list: 'v1/admin/leaveApplications',
    read: 'v1/admin/leaveApplications',
    create: 'v1/admin/leaveApplications',
    masterList: 'v1/master/leaveApplications',
  },
  booking: {
    list: 'v1/admin/bookings',
    read: 'v1/admin/bookings',
    create: 'v1/admin/bookings',
    masterList: 'v1/master/bookings',
  },
  timetable: {
    list: 'v1/admin/timetables',
    read: 'v1/admin/timetables',
    create: 'v1/admin/timetables',
  },
  transaction: {
    list: 'v1/admin/transactions',
    read: 'ec/transaction',
    create: 'ec/transaction',
  },
  physicalProducts: {
    list: 'v1/admin/PhysicalProducts',
    read: 'v1/admin/PhysicalProducts',
    create: 'v1/admin/PhysicalProducts',
    masterList: 'v1/master/PhysicalProducts',
  },
  physicalProductOrders: {
    list: 'v1/admin/ProductOrders',
    read: 'v1/admin/ProductOrders',
    create: 'v1/admin/ProductOrders',
  },
  EmployeeContract: {
    list: 'v1/admin/employeeContracts',
    read: 'v1/admin/employeeContracts',
    create: 'v1/admin/employeeContracts',
    masterList: 'v1/master/employeeContracts',
    masterRead: 'v1/master/employeeContracts',
  },
  teachingTasks: {
    list: 'v1/admin/teachingTasks',
    read: 'v1/admin/teachingTasks',
    create: 'v1/admin/teachingTasks',
  },
  payrollRecords: {
    list: 'v1/admin/payrollRecords',
    read: 'v1/admin/payrollRecords',
    create: 'v1/admin/payrollRecords',
    masterList: 'v1/master/payrollRecords',
    masterRead: 'v1/master/payrollRecords',
    update: 'v1/admin/payrollRecords',
  },
  cooperateCalendarEvents: {
    list: 'v1/admin/cooperateCalendarEvents',
    read: 'v1/admin/cooperateCalendarEvents',
    create: 'v1/admin/cooperateCalendarEvents',
  },
  crm: {
    list: 'v1/crm',
    read: 'v1/crm',
    create: 'v1/crm',
    update: 'v1/crm',
    generateN1: 'v1/crm/generate-n1',
    whatsappAttachmentSendStats: 'v1/crm/whatsapp-attachment-send-stats',
  },
  yomt: {
    list: 'v1/yomt',
    read: 'v1/yomt',
    create: 'v1/yomt',
    update: 'v1/yomt',
  },
  lpms: {
    list: 'v1/lpms',
    read: 'v1/lpms',
    create: 'v1/lpms',
    update: 'v1/lpms',
    generateBusinessno: 'v1/lpms/generate-businessno',
  },
  options: {
    list: 'v1/options',
    read: 'v1/options',
    create: 'v1/options',
    update: 'v1/options',
    delete: 'v1/options',
  },
  optOut: {
    list: 'v1/opt-outs',
    read: 'v1/opt-outs',
    create: 'v1/opt-outs',
    update: 'v1/opt-outs',
    delete: 'v1/opt-outs',
  },
  optLog: {
    list: 'v1/opt-logs',
    read: 'v1/opt-logs',
  },
  whatsappMessage: {
    list: 'v1/whatsapp-messages',
    read: 'v1/whatsapp-messages',
    conversations: 'v1/whatsapp-messages/conversations',
    byPhone: 'v1/whatsapp-messages/by-phone',
  },
  opt: {
    optInMessage: 'v1/opt/opt-in-message',
  },
  whatsappCloud: {
    policyDocsRequestWithoutAttachment:
      'v1/whatsapp-cloud/templates/policy-docs-request/without-attachment',
    policyRenewalNoticeWithoutAttachment:
      'v1/whatsapp-cloud/templates/policy-renewal-notice/without-attachment',
  },
  customer: {
    list: 'v1/autocomplete-profiles',
    read: 'v1/autocomplete-profiles',
    create: 'v1/autocomplete-profiles',
    update: 'v1/autocomplete-profiles',
    delete: 'v1/autocomplete-profiles',
  },
  agent: {
    list: 'v1/autocomplete-profiles',
    read: 'v1/autocomplete-profiles',
    create: 'v1/autocomplete-profiles',
    update: 'v1/autocomplete-profiles',
    delete: 'v1/autocomplete-profiles',
  },
  systemConfig: {
    getWhatsappAttachmentTotalSizeLimitMb: 'v1/system-config/get/crm/whatsappAttachmentTotalSizeLimitMb',
  },
};

export const roles = {
  admin: 'admin',
  client: 'customer',
  master: 'bn.master',
  cashier: 'bn.cashier',
};

export const paymentOfCreditCard = {
  ae: 'AE',
  visaOrMaster: 'Visa/Master',
  visa: 'Visa',
  master: 'Master',
  unionPay: 'Union Pay',
};

export const paymentOfOthers = {
  cash: 'Cash',
  octopusCard: 'Octopus Card',
  payMe: 'Payme',
  payPal: 'Paypal',
  alipayHK: 'Alipay HK',
  bankTransfer: 'Bank Transfer',
  cheque: 'Cheque',
  weChat: 'WeChat',
  onlinePay: 'Online Pay',
};

export const physicalProductOrderStatusTextTranslation = {
  pendingPayment: 'Pending Payment',
  pendingDelivery: 'Pending Delivery',
  completed: 'Completed',
  cancelled: 'Cancelled',
  expired: 'Expired',
};

export const leaveApplicationOption = {
  ByDate: 'ByDate',
  ByHour: 'ByHour',
};

export const leaveApplicationType = {
  sickLeave: 'SL',
  annualLeave: 'AL',
  noPayLeave: 'NPL',
  compensatoryLeave: 'CL',
  absent: 'Absent',
  statutoryHoliday: 'SH',
  familyHoliday: 'FH',
  otherLeave: 'Other',
};

export const leaveApplicationActionStatus = {
  leaveApplication: 'leaveApplication',
  absent: 'absent',
  leaveAdjustment: 'leaveAdjustment',
};
export const leaveApplicationStatus = {
  pending: '0$pending',
  approved: '1$approved',
  rejected: '99$rejected',
};

export const WORKING_HOURS_PER_DAY = 9;

export const payrollConstant = [
  {
    name: '___basicSalary_of_activatedContract___',

    description: 'The basic salary of activated contract ',
  },
  {
    name: '___diligenceAward_of_activatedContract___',
    description: 'The diligence award of activated contract',
  },
  {
    name: '___yearBonus_of_activatedContract___',
    description: 'The year bonus of activated contract',
  },
  {
    name: '___MPFRate_of_activatedContract___',
    description: 'The MPF Rate of activated contract',
  },
  {
    name: '___annualLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The annual leave selected month remaining of activated contract',
  },
  {
    name: '___sickLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The sick leave selected month remaining of activated contract',
  },
  {
    name: '___compensatoryLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The compensatory leave selected month remaining of activated contract',
  },
  {
    name: '___noPayLeave_selectedMonth_remaining_of_activatedContract___',
    description: 'The no pay leave selected month remaining of activated contract',
  },

  {
    name: '___servicePrice_for_seniority_of_activatedContract_n1___',
    description: 'The service price for seniority of activated contract n1',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n2___',
    description: 'The service price for seniority of activated contract n2',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n3___',
    description: 'The service price for seniority of activated contract n3',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n4___',
    description: 'The service price for seniority of activated contract n4',
  },
  {
    name: '___servicePrice_for_seniority_of_activatedContract_n5___',
    description: 'The service price for seniority of activated contract n5',
  },

  {
    name: '___cashierFeeRate___',
    description: 'The cashier fee rate',
  },
  {
    name: '___specificMasterFee___',
    description: 'The specific therapist fee',
  },

  {
    name: '___trainingFee_firstMonth___',
    description: 'The training fee first month',
  },
  {
    name: '___trainingFee_afterFirstMonth___',
    description: 'The training fee after first month',
  },

  {
    name: '___headcount_selectedMonth___',
    description: 'The headcount selected month',
  },
  {
    name: '___headcount_selectedMonth_assist___',
    description: 'The headcount selected month assist',
  },
  {
    name: '___headcount_selectedMonth_assist_n1___',
    description: 'The headcount selected month assist n1',
  },
  {
    name: '___headcount_selectedMonth_assist_n2___',
    description: 'The headcount selected month assist n2',
  },
  {
    name: '___headcount_selectedMonth_assist_n3___',
    description: 'The headcount selected month assist n3 ',
  },
  {
    name: '___headcount_selectedMonth_assist_n4___',
    description: 'The headcount selected month assist n4',
  },
  {
    name: '___headcount_selectedMonth_assist_n5___',
    description: 'The headcount selected month assist n5',
  },

  {
    name: '___headcount_selectedMonth_main___',
    description: 'The headcounts selected month main',
  },
  {
    name: '___headcount_selectedMonth_main_n1___',
    description: 'The headcounts selected month main n1',
  },
  {
    name: '___headcount_selectedMonth_main_n2___',
    description: 'The headcounts selected month main n2',
  },
  {
    name: '___headcount_selectedMonth_main_n3___',
    description: 'The headcounts selected month main n3',
  },
  {
    name: '___headcount_selectedMonth_main_n4___',
    description: 'The headcounts selected month main n4',
  },
  {
    name: '___headcount_selectedMonth_main_n5___',
    description: 'The headcounts selected month main n5',
  },

  {
    name: '___headcount_selectedMonth_total___',
    description: 'The headcount selected month total',
  },
  {
    name: '___headcount_selectedMonth_total_n1___',
    description: 'The headcount selected month total n1',
  },
  {
    name: '___headcount_selectedMonth_total_n2___',
    description: 'The headcount selected month total n2',
  },
  {
    name: '___headcount_selectedMonth_total_n3___',
    description: 'The headcount selected month total n3',
  },
  {
    name: '___headcount_selectedMonth_total_n4___',
    description: 'The headcount selected month total n4',
  },
  {
    name: '___headcount_selectedMonth_total_n5___',
    description: 'The headcount selected month total n5',
  },

  {
    name: '___studentCount_selectedMonth_firstMonth_activatedContract___',
    description: 'The student count selected month first month activated contract',
  },
  {
    name: '___studentCount_selectedMonth_secondAndThirdMonth_activatedContract___',
    description: 'The student count selected month second and third month activated contract',
  },
  {
    name: '___studentCount_selectedMonth_total_activatedContract___',
    description: 'The student count selectedMonth_total_activatedContract',
  },
  {
    name: '___ticketPackageSoldCommission_selectedMonth_total___',
    description: 'The ticket package sold commission selected month_total',
  },
  {
    name: '___physicalProductSoldCommission_selectedMonth_total___',
    description: 'The physical product sold commission selected month total',
  },
];

export const positions = {
  customer_service_officer: 'Customer Service Officer',
  hair_therapist: 'Herbal Hair Color Therapist',
  senior_hair_therapist: 'Herbal Hair Color Senior Therapist',
  supervisor: 'Shop Supervisor',
  manager: 'Shop Manager',
  assistant: 'Shop Assistant',
  sales_manager: 'Sales Manager',
  project_manager: 'Project Manager',
  director: 'Director',
  service_provider: 'Service Provider',
  other: 'Other',
};

export const defaultFormulaItems = [
  {
    outputTitle: 'Basic Salary',
    formula: '___basicSalary_of_activatedContract___',
    label: 'Basic Salary',
    remarks: 'default',
  },
  {
    outputTitle: 'Treatment Commission (Seniority)',
    formula:
      '___servicePrice_for_seniority_of_activatedContract_n1___*___headcount_selectedMonth_total_n1___+___servicePrice_for_seniority_of_activatedContract_n2___*___headcount_selectedMonth_total_n2___+___servicePrice_for_seniority_of_activatedContract_n3___*___headcount_selectedMonth_total_n3___+___servicePrice_for_seniority_of_activatedContract_n4___*___headcount_selectedMonth_total_n4___+___servicePrice_for_seniority_of_activatedContract_n5___*___headcount_selectedMonth_total_n5___' +
      '+___servicePrice_for_seniority_of_activatedContract_hg1___*___headcount_selectedMonth_total_hg1___+___servicePrice_for_seniority_of_activatedContract_hg2___*___headcount_selectedMonth_total_hg2___+___servicePrice_for_seniority_of_activatedContract_hg3___*___headcount_selectedMonth_total_hg3___+___servicePrice_for_seniority_of_activatedContract_hg4___*___headcount_selectedMonth_total_hg4___+___servicePrice_for_seniority_of_activatedContract_hg5___*___headcount_selectedMonth_total_hg5___' +
      '+___servicePrice_for_seniority_of_activatedContract_hl1___*___headcount_selectedMonth_total_hl1___+___servicePrice_for_seniority_of_activatedContract_hl2___*___headcount_selectedMonth_total_hl2___+___servicePrice_for_seniority_of_activatedContract_hl3___*___headcount_selectedMonth_total_hl3___+___servicePrice_for_seniority_of_activatedContract_hl4___*___headcount_selectedMonth_total_hl4___+___servicePrice_for_seniority_of_activatedContract_hl5___*___headcount_selectedMonth_total_hl5___' +
      '+___servicePrice_for_seniority_of_activatedContract_o1___*___headcount_selectedMonth_total_o1___+___servicePrice_for_seniority_of_activatedContract_o2___*___headcount_selectedMonth_total_o2___+___servicePrice_for_seniority_of_activatedContract_o3___*___headcount_selectedMonth_total_o3___+___servicePrice_for_seniority_of_activatedContract_o4___*___headcount_selectedMonth_total_o4___+___servicePrice_for_seniority_of_activatedContract_o5___*___headcount_selectedMonth_total_o5___',
    label: 'Treatment Commission (Seniority)',
    remarks: 'default',
  },
  {
    outputTitle: 'Over 110',
    formula: 'Math.max(___headcount_selectedMonth_total___-110 , 0) *100',
    label: 'Over 110',
    remarks: 'default',
  },
  {
    outputTitle: 'Product Commission',
    formula: '___physicalProductSoldCommission_selectedMonth_total___',
    label: 'Product Commission',
    remarks: 'default',
  },
  {
    outputTitle: 'Package Commission',
    formula: '___ticketPackageSoldCommission_selectedMonth_total___',
    label: 'Product Commission',
    remarks: 'default',
  },
  {
    outputTitle: 'Specific Therapist Fee',
    formula: '___specificMasterFee___*___master_specified_count_selectedMonth_total___',
    label: 'Specific Therapist Fee',
    remarks: 'default',
  },
  {
    outputTitle: 'No Pay Leave',
    formula:
      '___basicSalary_of_activatedContract___*12/365*-1*___noPayLeave_selectedMonth_of_activatedContract___/___working_hours_of_a_day___',
    label: 'No Pay Leave',
    remarks: 'No Pay Leave',
  },
  {
    outputTitle: 'Absent',
    formula:
      '___basicSalary_of_activatedContract___*12/365*-1*___absent_selectedMonth_of_activatedContract___/___working_hours_of_a_day___',
    label: 'Absent',
    remarks: 'Absent',
  },
  // {
  //   outputTitle: 'Other Leave',
  //   formula:
  //     '___basicSalary_of_activatedContract___*12/365*-1*___otherLeave_selectedMonth_of_activatedContract___/___working_hours_of_a_day___',
  //   label: 'Other Leave',
  //   remarks: 'Other Leave',
  // },
  // {
  //   outputTitle: 'Teacher Fee',
  //   formula: '___trainingFee_firstMonth___ + ___trainingFee_afterFirstMonth___',
  //   label: 'Teacher Fee',
  //   remarks: 'default',
  // },
];
export const transactionTypes = {
  // for meatadata
  TicketsPackage: 'BNTicketsPackage',
  Booking: 'BNBooking',
  Redo: 'computedRedo',
  PhysicalProductOrder: 'BNPhysicalProductOrder',
  PayrollRecord: 'BNPayrollRecord',
  computedOnlineOrder: 'computedOnlineOrder',
  computedProductInService: 'computedProductInService',
  computedServiceOnly: 'computedServiceOnly',
};
export const transactionRefs = [
  // for refs
  'BNTicketsPackage',
  'BNBooking',
  'BNProductOrder',
  'BNPayrollRecord',
];

export const calendarEventType = {
  default: 'default',
  holiday: 'holiday',
  other: 'other',
};

// export const paymentStatus = {
//   pending: 'pending',
//   paid: 'paid',
//   fail: 'fail',
// };

export const productOrderDiscountType = {
  byValue: 'byValue',
  byPercentage: 'byPercentage',
};

export const serviceProductServiceType = {
  N: 'N',
  HG: 'HG',
  HL: 'HL',
  Other: 'Other',
};
export const serviceProductServiceTypeEmojiHashMap = {
  [serviceProductServiceType.N]: '🎨',
  [serviceProductServiceType.HG]: '👶🏻',
  [serviceProductServiceType.HL]: '🖍️',
  [serviceProductServiceType.Other]: '❓',
};

// tableManagement

export const tableManagementStatus = {
  pending: '0$pending',
  matched: '10$matched',
  completed: '80$completed',
  cancelled: '90$cancelled',
  expired: '99$expired',
};

export const tableManagementType = {
  free: 'free',
  paid: 'paid',
  premium: 'premium',
};

// tableApplication
export const tableApplicationStatus = {
  pending: '0$pending',
  matched: '10$matched',
  completed: '80$completed',
  cancelled: '90$cancelled',
  expired: '99$expired',
};

export const tableManagementGenderPreference = {
  male: 'male',
  female: 'female',
  both: 'both',
};

export const tableManagementAgeRangePreference = {
  nonSupport: 'nonSupport',
  '18-23': '18-23',
  '24-30': '24-30',
  '31-40': '31-40',
  '41-99': '41-99',
};

export const tableManagementHeightRangePreference = {
  // in cm
  nonSupport: 'nonSupport',
  '0-159': '0-159',
  '160-165': '160-165',
  '166-170': '166-170',
  '171-250': '171-250',
};

export const tableManagementMBTIPreference = {
  nonSupport: 'nonSupport',
  extrovert: 'extrovert',
  introvert: 'introvert',
  neutral: 'neutral',
  unknown: 'unknown',
};

export const tableManagementPaymentType = {
  nonSupport: 'nonSupport',
  full: 'full',
  splitBill: 'splitBill',
  joinerPay: 'joinerPay',
};

export const profileGender = {
  male: 'male',
  female: 'female',
  unknown: 'unknown',
  nonBinary: 'nonBinary',
};

export const profileGenderPreference = {
  male: 'male',
  female: 'female',
  both: 'both',
};

export const subscriptionPlanStatus = {
  inactive: '0$inactive',
  active: '1$active',
  suspended: '10$suspended',
};

export const subscriptionPlanPaymentStatus = {
  pending: 'pending',
  paid: 'paid',
  waitingForApproval: 'waitingForApproval',
  fail: 'fail',
};
export const subscriptionPlanExtendType = {
  purchase: 'purchase',
  renewal: 'renewal',
  manual: 'manual',
};
export const billingStatus = {
  pending: 'pending',
  completed: 'completed',
  failed: 'failed',
  cancelled: 'cancelled',
  voided: 'voided',
};

export const notificationType = {
  info: 'info',
  warning: 'warning',
  error: 'error',
  success: 'success',
};

export const activityLogStatus = {
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

export const paymentStatus = {
  CREATED: '0$created',
  COMPLETED: '1$completed',
  CANCELLED: '99$cancelled',
};

export const tableManagementActivityType = {
  watchMovie: 'watchMovie',
  sport: 'sport',
  eatOrDrink: 'eatOrDrink',
  other: 'other',
};

export const billingProductType = {
  // createFreeTableManagement: 'createFreeTableManagement',
  createPaidTableManagement: 'createPaidTableManagement',
  createPremiumTableManagement: 'createPremiumTableManagement',
  upgradeTableManagement: 'upgradeTableManagement',
  unpickApplication: 'unpickApplication',
};
// LPMS State Constants ,
// beware below value should be value that used in db ,
// for display , need lookup the options and display the text in traditional chinese
export const lpmsState = {
  renewed: '已续期',
  expired: '已過期',
  selling: '售出中',
  sold: '已售出',
  underHandling: '辦理中',
  abandonedToSell: '放棄出售',
  custodian: '託管',
  custodianSelling: '託管出售',
};

// CRM Options SubTypes
// beware below value should be value that used in db ,
// for display , need lookup the options and display the text in traditional chinese
/** Options collection `type` values (see backend option seeds). */
export const optionTypes = {
  crm: 'crm',
};

export const crmOptionsSubTypes = {
  insuranceCompany: '保险公司管理',
  insuredPlace: '投保地点管理',
  agency: '代理管理',
  fileStoragePlace: '文件存放地点管理',
};

// YOMT Options SubTypes
export const yomtOptionsSubTypes = {
  vehicleRegistration: '車輛登記及牌照',
  drivingLicense: '駕駛執照',
  personalVehicleChange: '更改個人或車輛資料',
};

export const lpmsFileTypes = {
  retentionCertificate: '留牌紙',
  vehicleRegistrationBook: '牌薄',
};

export const insuranceTypes = {
  ThirdParty: '3rd party',
  Comp: 'Comp',
  MT: 'MT',
  Ship: 'Ship',
  Fire: 'Fire',
  EC: 'EC',
  Business: 'Business',
};

export const rnTypes = {
  RN: 'RN',
  NoTel: 'No Tel',
  NoWhatsapp: 'No Whatsapp',
  Renewed: 'Renewed',
  NonRenewal: 'Non-Renewal',
  Cancelled: 'Cancelled',
  Sold: 'Sold',
  Abandoned: 'abandoned',
  PhoneCall: 'phoneCall',
  Mailed: 'mailed',
  Sold: 'Sold',
};
